"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VARIANT_STATES = exports.AB_STATES = exports.SCHEDULED_STATES = exports.DRAFT_STATES = exports.PUBLISHED_STATES = exports.ITEMS_PER_PAGE = exports.SITE_PAGES = exports.PagesQueryParamNames = exports.PageProperties = exports.FilterablePageStates = exports.PageStates = void 0;

var _immutable = require("immutable");

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var PageStates = (0, _keyMirror.default)({
  PUBLISHED: null,
  PUBLISHED_OR_SCHEDULED: null,
  DRAFT: null,
  SCHEDULED: null,
  PUBLISHED_AB: null,
  PUBLISHED_AB_VARIANT: null,
  LOSER_AB_VARIANT: null,
  DRAFT_AB: null,
  DRAFT_AB_VARIANT: null,
  SCHEDULED_AB: null
});
exports.PageStates = PageStates;
var FilterablePageStates = {
  ALL: 'all',
  DRAFT: 'draft',
  SCHEDULED: 'scheduled',
  PUBLISHED: 'published',
  AB: 'ab',
  ARCHIVED: 'archived'
};
exports.FilterablePageStates = FilterablePageStates;
var PageProperties = {
  ID: 'id',
  NAME: 'name',
  URL: 'url',
  PUBLIC_ACCESS_RULES_ENABLED: 'publicAccessRulesEnabled'
};
exports.PageProperties = PageProperties;
var PagesQueryParamNames = {
  SEARCH: 'search',
  PAGE: 'page',
  IDS: 'ids'
};
exports.PagesQueryParamNames = PagesQueryParamNames;
var SITE_PAGES = 'sitePages';
exports.SITE_PAGES = SITE_PAGES;
var ITEMS_PER_PAGE = 50;
exports.ITEMS_PER_PAGE = ITEMS_PER_PAGE;
var PUBLISHED_STATES = (0, _immutable.Set)([PageStates.PUBLISHED, PageStates.PUBLISHED_OR_SCHEDULED, PageStates.PUBLISHED_AB, PageStates.PUBLISHED_AB_VARIANT]);
exports.PUBLISHED_STATES = PUBLISHED_STATES;
var DRAFT_STATES = (0, _immutable.Set)([PageStates.DRAFT, PageStates.DRAFT_AB, PageStates.DRAFT_AB_VARIANT, PageStates.LOSER_AB_VARIANT]);
exports.DRAFT_STATES = DRAFT_STATES;
var SCHEDULED_STATES = (0, _immutable.Set)([PageStates.SCHEDULED, PageStates.SCHEDULED_AB, PageStates.PUBLISHED_OR_SCHEDULED]);
exports.SCHEDULED_STATES = SCHEDULED_STATES;
var AB_STATES = (0, _immutable.Set)([PageStates.DRAFT_AB, PageStates.DRAFT_AB_VARIANT, PageStates.SCHEDULED_AB, PageStates.PUBLISHED_AB, PageStates.PUBLISHED_AB_VARIANT, PageStates.LOSER_AB_VARIANT]);
exports.AB_STATES = AB_STATES;
var VARIANT_STATES = (0, _immutable.Set)([PageStates.PUBLISHED_AB_VARIANT, PageStates.DRAFT_AB_VARIANT, PageStates.LOSER_AB_VARIANT]);
exports.VARIANT_STATES = VARIANT_STATES;